import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import type { Ref } from 'vue'
import {
  HQ_VPN_LANGUAGE_COOKIE_NAME,
} from '@/const'


export default /*#__PURE__*/_defineComponent({
  __name: 'GMap',
  props: ['lang', 'lat', 'long' ],
  setup(__props, { expose }) {
  expose();

const props = __props





const __returned__ = { props, onMounted, ref, HQ_VPN_LANGUAGE_COOKIE_NAME }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})